var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.19 2H7.81C4.60123 2 2 4.60123 2 7.81V16.19C2 19.3988 4.60123 22 7.81 22H16.19C19.3988 22 22 19.3988 22 16.19V7.81C22 4.60123 19.3988 2 16.19 2Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.41 11.9999L16.24 9.16994C16.3447 9.0803 16.4297 8.96998 16.4898 8.84591C16.5498 8.72185 16.5835 8.58672 16.5888 8.449C16.5941 8.31128 16.5709 8.17395 16.5207 8.04562C16.4704 7.9173 16.3941 7.80075 16.2967 7.70329C16.1992 7.60584 16.0827 7.52958 15.9544 7.47931C15.826 7.42903 15.6887 7.40583 15.551 7.41115C15.4133 7.41647 15.2781 7.4502 15.1541 7.51022C15.03 7.57024 14.9197 7.65526 14.83 7.75994L12 10.5899L9.17003 7.75994C8.97873 7.59612 8.73265 7.51051 8.48098 7.52023C8.2293 7.52995 7.99056 7.63429 7.81247 7.81238C7.63437 7.99048 7.53004 8.22921 7.52032 8.48089C7.5106 8.73257 7.5962 8.97864 7.76003 9.16994L10.59 11.9999L7.76003 14.8299C7.57378 15.0173 7.46924 15.2708 7.46924 15.5349C7.46924 15.7991 7.57378 16.0526 7.76003 16.2399C7.94739 16.4262 8.20085 16.5307 8.46503 16.5307C8.72922 16.5307 8.98267 16.4262 9.17003 16.2399L12 13.4099L14.83 16.2399C15.0174 16.4262 15.2708 16.5307 15.535 16.5307C15.7992 16.5307 16.0527 16.4262 16.24 16.2399C16.4263 16.0526 16.5308 15.7991 16.5308 15.5349C16.5308 15.2708 16.4263 15.0173 16.24 14.8299L13.41 11.9999Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSquare);
export default __webpack_public_path__ + "static/media/cross-square.1bf421d84128b1766f10b83d67396fa1.svg";
export { ForwardRef as ReactComponent };